import './config';
import './loader_static';

export function getBlackbox() {
  return window.IGLOO.getBlackbox().blackbox;
}
